import { useAppSelector } from 'app/store/store.hooks';
import { getIsSelfRegistered } from 'entities/Account/Account.helper';
import { getUserRole } from 'entities/User/User.helper';

const useCurrentUserRole = (): {
  isSuperAdmin: boolean;
  isAccountAdmin: boolean;
  isSellerManager: boolean;
  isManager: boolean;
  isHeadOfDepartment: boolean;
  isUser: boolean;
} => {
  const currentUser = useAppSelector((state) => state.user.currentUser);

  return getUserRole(currentUser?.roles);
};

const useIsSelfRegistered = (): { isSelfRegistered: boolean } => {
  const currentUser = useAppSelector((state) => state.user.currentUser);

  return { isSelfRegistered: getIsSelfRegistered(currentUser?.account) };
};

export const UserHooks = {
  useCurrentUserRole,
  useIsSelfRegistered,
};
